export default class AgentWhatsAppLoginAction {
  constructor(agentId) {
    this.agentId = agentId;
    this.action = 'AgentWhatsAppLoginAction';

    window.console.log('Enviando informações de Login em whatsApp: ', this);
  }
}
